module.exports = __webpack_public_path__ + "assets/img/BankCard_2.763dd600.png";